import React from 'react';
import {
	Box,
	FormControl,
	FormLabel,
	Checkbox,
	Tooltip,
} from '@chakra-ui/react';

export const ProfileCheckbox = ({ w, state, setter, name, en, ru }) => {
	const onChange = e => setter({ ...state, [e.target.name]: e.target.checked });

	const tooltip = { label: ru, placement: 'top-start' };
	const checkbox = {
		defaultIsChecked: state[name],
		onChange,
		name,
	};

	return (
		<FormControl w={w}>
			<FormLabel>&nbsp;</FormLabel>
			<Tooltip {...tooltip}>
				<Box>
					<Checkbox {...checkbox}>{en}</Checkbox>
				</Box>
			</Tooltip>
		</FormControl>
	);
};
